import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

/**
 * LA SONDA DI CATTURA (tappa 1 del Feedback con la schermata; cantiere tma-orcr-95, «via» di tma-orcr 30/10 20:04Z): una pagina di STAGING che misura, sul telefono
 * del tester, cosa la cattura in pagina riesce a fotografare (`/settings/sonda-cattura`, dietro `beta`). L'esito e' un JSON da copiare a mano: nessun backend.
 *
 * 🔴 FLAG LETTERALE (`import.meta.env.VITE_FEATURE_SONDA_CATTURA_ENABLED === 'true'`), acceso SOLO in `.env.staging`, e scritto per esteso in ogni punto che decide un
 * chunk: il bundler piega il confronto e in produzione non resta niente — ne' la riga in Impostazioni, ne' la pagina, ne' snapdom (ADR-0229 §5; la trappola e'
 * quella di `lib/minigiochi.ts`: una chiamata non si piega). Lo prova `tools/verify-sonda-cattura.ts` sul sorgente e sul bundle di produzione.
 */
export const SONDA_IN_BUILD = import.meta.env.VITE_FEATURE_SONDA_CATTURA_ENABLED === 'true';

/** La riga di Impostazioni (solo `SettingsHome`, mai lo Zaino: v. `conSonda` in `SettingsList`). `null` in produzione. */
export const VoceSondaCattura: LazyExoticComponent<ComponentType> | null =
  import.meta.env.VITE_FEATURE_SONDA_CATTURA_ENABLED === 'true' ? lazy(() => import('@/components/sonda/VoceSondaCattura')) : null;

/** La pagina. `null` in produzione: il router non registra la rotta. */
export const PaginaSondaCattura: LazyExoticComponent<ComponentType> | null =
  import.meta.env.VITE_FEATURE_SONDA_CATTURA_ENABLED === 'true' ? lazy(() => import('@/routes/settings/SondaCattura')) : null;
